<template>
  <section class="people min-w-0">
    <Carousel>
      <template #title>
        <h2 class="font-semibold text-xl tracking-normal pb-4 lg_text-2xl">Management &amp; Directors</h2>
      </template>
      <CarouselSlide
        v-for="companyPerson in people"
        :key="companyPerson.id"
        class="person"
        :data-testid="`person-${companyPerson.person_id}`"
      >
        <div class="w-full flex flex-col items-center">
          <img v-if="companyPerson.image" class="h-24 w-24 rounded-full mb-4" :src="companyPerson.image" :alt="companyPerson.person.name" />
          <IconsProfilePlaceholder v-else class="h-24 w-24 mb-4" />
          <div class="person-info text-center text-sm">
            <div class="name mb-1">{{ companyPerson.person.name }}</div>
            <div class="text-gray-800" :data-testid="`${companyPerson.person_id}-title`">{{ companyPerson.title }}</div>
          </div>
        </div>
      </CarouselSlide>
    </Carousel>
  </section>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import type { CompanyPerson } from '@/entities/companyPerson'
import IconsProfilePlaceholder from '@/components/icons/ProfilePlaceholder.svg'

defineProps({
  people: {
    type: Array as PropType<DeepReadonly<CompanyPerson[]>>,
    default: () => [],
  },
})
</script>

<style lang="stylus">
.person
  width: 140px
@screen sm
  .person
    width: 130px
@screen md
  .person
    width: 168px
@screen lg
  .person
    width: 124.5px
@screen xl
  .person
    width: 156px
@screen xl1
  .person
    width: 127px
@screen xl2
  .person
    width: 158px
</style>
